import api from '../api';

export const getListMedia = async () => {
    const result = await api.get('/admin/media');
    return result.data;
}

export const addMedia = async (data) => {
    try {
        const response = await api.post('/admin/media', data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateMedia = async (data, id) => {
    return await api.post(`/admin/media/${id}`, data);
}

export const deleteMedia = async (id) => {
    try {
        const response = await api.delete(`/admin/media/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}



